export default __webpack_public_path__ + "static/media/m_engineering_card09_1.43cb98d7.png";